import { isAvailable, Feature } from 'App/services/FeatureHelperStandalone';
import AppService from 'App/legacy/AppService';
export default function allowed() {
	const self = AppService.getSelf();
	if (!isAvailable(Feature.SOCIAL_EVENTS)) {
		return false;
	}

	const hasEventAccess = AppService.getAccessRights().SocialEvent;
	if (!self.userParams.mailAdmin && !self.administrator && !hasEventAccess) {
		return false;
	}

	return true;
}
